import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Custom hook to handle scroll to top on route changes
export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Clear any existing scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Function to scroll to top
    const scrollToTop = () => {
      // Try multiple methods to ensure scrolling works
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    };

    // Immediate scroll
    scrollToTop();

    // Fallback with timeout
    const timeoutId = setTimeout(scrollToTop, 10);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
    };
  }, [location.pathname, location.search]);
};

export default useScrollToTop;